import { CONFIG } from '../config';
import styles from './Capabilities.module.css';

export default function Capabilities() {
  return (
    <section className={styles.section} id="capabilities">
      <div className={styles.header}>
        <div className={styles.tag}>Core Arsenal</div>
        <h2 className={styles.title}>Battle-Ready Capabilities</h2>
        <p className={styles.desc}>Every weapon in the arsenal is optimized for maximum ecosystem impact on Base.</p>
      </div>

      <div className={styles.grid}>
        {CONFIG.capabilities.map((cap) => (
          <div key={cap.num} className={styles.card}>
            <span className={styles.icon}>{cap.icon}</span>
            <span className={styles.num}>{cap.num}</span>
            <div className={styles.cardTitle}>{cap.title}</div>
            <p className={styles.cardDesc}>{cap.desc}</p>
            <span className={styles.cardTag}>{cap.tag}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
